export const normalizeMatchTitleValues = (...values) => [
  ...new Set(values.flat().filter(Boolean))
].slice(0, 2)

export const getMatchTitleValues = (match = {}) => {
  if (Array.isArray(match?.titles) && match.titles.length > 0) {
    return normalizeMatchTitleValues(match.titles)
  }

  return normalizeMatchTitleValues(match?.title, match?.secondaryTitle)
}

export const isTitleMatch = (match = {}) => getMatchTitleValues(match).length > 0

export const getMatchTitleObjects = (match = {}, championships = []) => {
  const championshipByValue = new Map(
    championships.map(championship => [championship.value, championship])
  )

  return getMatchTitleValues(match)
    .map(titleValue => championshipByValue.get(titleValue))
    .filter(Boolean)
}

export const getMatchTitleLabel = (match = {}, championships = []) => {
  const titleValues = getMatchTitleValues(match)
  if (titleValues.length === 0) return ''

  const championshipByValue = new Map(
    championships.map(championship => [championship.value, championship.name])
  )

  return titleValues
    .map(titleValue => championshipByValue.get(titleValue) || titleValue)
    .join(' + ')
}
